import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Woof from '../views/Woof.vue'
import Meow from '../views/Meow.vue'
import Profile from '../views/Profile.vue'
import Login from '../views/Login.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/meow',
    name: 'Meow',
    component: Meow
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/woof',
    name: 'Woof',
    component: Woof
  }
]

const router = new VueRouter({
  routes
})

export default router
